import { FC, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { IModalProps } from './types';

export const ModalPortal: FC<IModalProps> = ({
  children,
  nodeId = 'modalRoot',
  tagName = 'div',
}) => {

  const container = useRef<HTMLDivElement>(document.createElement(tagName));

  useEffect(() => {
    const modalRoot = document.getElementById(nodeId);
    const root = document.getElementById('root');
    if (modalRoot) modalRoot.appendChild(container.current);
    if (root) root.setAttribute('aria-hidden', 'true');
    return () => {
      if (modalRoot) modalRoot.removeChild(container.current);
      if (root) root.setAttribute('aria-hidden', 'false');
    };
  }, []);

  return ReactDOM.createPortal(
    children,
    container.current
  );
};
